import axios from 'axios'
import fileSaver from 'file-saver'

function folderCommandBase (rootState, propertyId) {
  var companyPath = `/api/company/${rootState.userCurrentCompany.companyId}`
  if (propertyId === null || propertyId === undefined || propertyId === '') {
    return `${companyPath}/resources/folders`
  }
  return `${companyPath}/properties/${propertyId}/resources/folders`
}

function fileCommandBase (rootState, propertyId) {
  var companyPath = `/api/company/${rootState.userCurrentCompany.companyId}`
  if (propertyId === null || propertyId === undefined || propertyId === '') {
    return `${companyPath}/resources/files`
  }
  return `${companyPath}/properties/${propertyId}/resources/files`
}

// ?showArchived=true for folder content GETs (Resources Explorer F3)
function archivedParams (args) {
  return args && args.showArchived === true ? { params: { showArchived: true } } : undefined
}

function postFolderCommand (apiPath, body, method) {
  var request = method === 'delete' ? axios.delete(apiPath) : axios.post(apiPath, body)
  return request.then((result) => {
    var data = result.data || {}
    if (data.success !== true && !data.failureReason) {
      data.failureReason = 'The request could not be completed.'
    }
    return data
  }).catch((e) => {
    var data = (e && e.response && e.response.data) || {}
    var reason = (typeof data === 'object' && data.failureReason) || (typeof data === 'string' && data.length < 300 && data) || 'The request failed. Please try again.'
    console.log(`Error: the server responded with '${e}'`)
    return { success: false, failureReason: reason }
  })
}

// Multipart upload config. Optional (F4a): args.onUploadProgress, args.cancelToken (axios CancelToken).
function uploadConfig (args) {
  var config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: {name: args.name, note: args.note}
  }
  if (typeof args.onUploadProgress === 'function') config.onUploadProgress = args.onUploadProgress
  if (args.cancelToken) config.cancelToken = args.cancelToken
  return config
}

// Old callers: errors are logged and swallowed (resolves undefined). args.throwOnError === true rethrows.
function uploadError (args, error) {
  console.log(error)
  if (args.throwOnError === true) throw error
}

// Documents API (DOCS_API_URL) scope prefix (F4b): company or `property/{propertyId}` (singular).
function docsScope (rootState, propertyId) {
  var companyPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}`
  if (propertyId === null || propertyId === undefined || propertyId === '') return companyPath
  return `${companyPath}/property/${propertyId}`
}

// Multipart config for the F4b version / replace uploads (no name/note params).
function versionUploadConfig (args) {
  var config = { headers: { 'Content-Type': 'multipart/form-data' } }
  if (typeof args.onUploadProgress === 'function') config.onUploadProgress = args.onUploadProgress
  if (args.cancelToken) config.cancelToken = args.cancelToken
  return config
}

function fileFormData (file) {
  var formData = new FormData()
  formData.append('file', file)
  return formData
}

export default{
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getResources ({commit, state, rootState}, args) {
      var eventPath = args.eventId !== undefined ? `events/${args.eventId}/` : ''
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources`
      return axios.get(apiPath, archivedParams(args)).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getResourcesByFolderId ({commit, state, rootState}, args) {
      console.log('args: ' + JSON.stringify(args, null, 2))

      var apiPath = ''
      var config
      var eventPath = args.eventId !== undefined ? `events/${args.eventId}/` : ''
      if (args.folderType.toLowerCase() === 'property' && args.propertyId === null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources/properties`
      } else if (args.folderType.toLowerCase() === 'property' && args.propertyId !== null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/${eventPath}resources/folders/${args.folderId}`
        config = archivedParams(args)
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources/folders/${args.folderId}`
        config = archivedParams(args)
      }

      return axios.get(apiPath, config).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getFolderForEdit ({rootState}, args) {
      var apiPath = ''
      var eventPath = args.eventId !== undefined ? `events/${args.eventId}/` : ''

      if (args.propertyId === null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources/folders/${args.folderId}/edit`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/${eventPath}resources/folders/${args.folderId}/edit`
      }
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async saveFolder ({rootState}, args) {
      console.log('Saving folder: ' + JSON.stringify(args.folder, null, 2))
      var apiPath = ''

      if (args.folder.eventId !== undefined) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.folder.eventId}/resources/folders/save`
      } else if (args.folder.propertyId === null || args.folder.propertyId === undefined) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/resources/folders/save`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.folder.propertyId}/resources/folders/save`
      }
      return axios.post(apiPath, args.folder).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    // Folder create-path / rename / move (Resources Explorer F2).
    // args: { propertyId|null, ... }. Always resolves to { success, failureReason, folder, createdFolderIds, affectedFolderIds }.
    async createFolderPath ({rootState}, args) {
      return postFolderCommand(folderCommandBase(rootState, args.propertyId) + '/create-path', { parentId: args.parentId || null, path: args.path })
    },
    async renameFolder ({rootState}, args) {
      return postFolderCommand(folderCommandBase(rootState, args.propertyId) + `/${args.folderId}/rename`, { name: args.name })
    },
    async moveFolder ({rootState}, args) {
      return postFolderCommand(folderCommandBase(rootState, args.propertyId) + `/${args.folderId}/move`, { targetParentId: args.targetParentId || null })
    },
    // Archive / restore / delete (Resources Explorer F3). Same response shape: { success, failureReason, affectedFolderIds, affectedFileIds }.
    async archiveFolder ({rootState}, args) {
      return postFolderCommand(folderCommandBase(rootState, args.propertyId) + `/${args.folderId}/archive`, {})
    },
    async restoreFolder ({rootState}, args) {
      return postFolderCommand(folderCommandBase(rootState, args.propertyId) + `/${args.folderId}/restore`, {})
    },
    async deleteFolder ({rootState}, args) {
      return postFolderCommand(folderCommandBase(rootState, args.propertyId) + `/${args.folderId}`, null, 'delete')
    },
    async archiveFile ({rootState}, args) {
      return postFolderCommand(fileCommandBase(rootState, args.propertyId) + `/${args.fileId}/archive`, {})
    },
    async restoreFile ({rootState}, args) {
      return postFolderCommand(fileCommandBase(rootState, args.propertyId) + `/${args.fileId}/restore`, {})
    },
    // Documents
    uploadDocument ({rootState}, args) {
      console.log('Upload clicked. for event: ' + args.name)
      console.log('stringify ', JSON.stringify(args, null, 2))
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}/${args.documentTypeId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData, uploadConfig(args))
        .then((result) => {
          return result
        }).catch(error => {
          uploadError(args, error)
        })
    },
    async downloadDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for document:', args.documentId)
      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/documents/${args.documentId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Delete clicked for document: ' + args.name)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/documents/${args.documentId}`
      }
      return axios.delete(apiPath, {params: {shouldPermanentlyDelete: args.shouldPermanentlyDelete === true}})
        .then((result) => {
          return result.data
        }).catch(error => {
          console.log(error)
        })
    },
    moveDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Move clicked for document: ' + args.documentId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}/move`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}/move`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/documents/${args.documentId}/move`
      }
      return axios.get(apiPath, {params: {folderId: args.folderId}})
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    // Images
    uploadImage ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for image: ' + args.name)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData, uploadConfig(args))
        .then((result) => {
          return result
        }).catch(error => {
          uploadError(args, error)
        })
    },
    async downloadImage ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for image:', args.imageId)
      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/images/${args.imageId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteImage ({commit, state, rootState, dispatch}, args) {
      console.log('Delete clicked for image: ' + args.name)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/images/${args.imageId}`
      }
      return axios.delete(apiPath, {params: {shouldPermanentlyDelete: args.shouldPermanentlyDelete === true}})
        .then((result) => {
          return result.data
        }).catch(error => {
          console.log(error)
        })
    },
    moveImage ({commit, state, rootState, dispatch}, args) {
      console.log('Move clicked for document: ' + args.imageId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}/move`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}/move`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/images/${args.imageId}/move`
      }
      return axios.get(apiPath, {params: {folderId: args.folderId}})
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    // Videos
    uploadVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for video: ' + args.name)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData, uploadConfig(args))
        .then((result) => {
          return result
        }).catch(error => {
          uploadError(args, error)
        })
    },
    async downloadVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for video:', args.videoId)
      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/videos/${args.videoId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Delete clicked for video: ' + args.name)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/videos/${args.videoId}`
      }
      return axios.delete(apiPath, {params: {shouldPermanentlyDelete: args.shouldPermanentlyDelete === true}})
        .then((result) => {
          return result.data
        }).catch(error => {
          console.log(error)
        })
    },
    moveVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Move clicked for video: ' + args.videoId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}/move`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}/move`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/videos/${args.videoId}/move`
      }
      return axios.get(apiPath, {params: {folderId: args.folderId}})
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    getMoveFoldersForDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Getting move folders for: ' + args.documentId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}/move/folders`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}/move/folders`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/documents/${args.documentId}/move/folders`
      }
      return axios.get(apiPath)
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    getMoveFoldersForImage ({commit, state, rootState, dispatch}, args) {
      console.log('Getting move folders for: ' + args.imageId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}/move/folders`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}/move/folders`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/images/${args.imageId}/move/folders`
      }
      return axios.get(apiPath)
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    getMoveFoldersForVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Getting move folders for: ' + args.videoId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}/move/folders`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}/move/folders`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/videos/${args.videoId}/move/folders`
      }
      return axios.get(apiPath)
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    // ---------- Resources Explorer F4b: versions, replace, rename, zip ----------
    // args: { propertyId|null, folderId, names: [string] } -> { conflicts: [{ name, fileId, existingName, existingFileName, fileType }] }
    // Rejects on failure.
    getNameConflicts ({rootState}, args) {
      var query = (args.names || []).map(function (n) { return 'names=' + encodeURIComponent(n) }).join('&')
      var apiPath = docsScope(rootState, args.propertyId) + `/resources/folders/${args.folderId}/name-conflicts` + (query ? '?' + query : '')
      return axios.get(apiPath).then(function (result) {
        var data = result.data || {}
        return { conflicts: Array.isArray(data.conflicts) ? data.conflicts : [] }
      })
    },
    // args: { propertyId|null, fileId, fileName, file, onUploadProgress?, cancelToken? } -> axios response ({ versionNumber, file }). Rejects on failure.
    uploadFileVersion ({rootState}, args) {
      var apiPath = docsScope(rootState, args.propertyId) + `/resources/files/${args.fileId}/versions/${encodeURIComponent(args.fileName)}`
      return axios.post(apiPath, fileFormData(args.file), versionUploadConfig(args))
    },
    // Replace the current file contents without keeping history. Same args / result as uploadFileVersion.
    replaceFile ({rootState}, args) {
      var apiPath = docsScope(rootState, args.propertyId) + `/resources/files/${args.fileId}/replace/${encodeURIComponent(args.fileName)}`
      return axios.post(apiPath, fileFormData(args.file), versionUploadConfig(args))
    },
    // args: { propertyId|null, fileId, number, fileName } -> saves the version's bytes. Rejects on failure.
    downloadFileVersion ({rootState}, args) {
      var apiPath = docsScope(rootState, args.propertyId) + `/resources/files/${args.fileId}/versions/${args.number}`
      return axios.get(apiPath, { responseType: 'blob', headers: { 'accept': 'application/octet-stream' } }).then(function (response) {
        fileSaver.saveAs(response.data, args.fileName)
        return true
      })
    },
    // args: { propertyId|null, fileId, number } -> { versionNumber, file }. Rejects on failure.
    restoreFileVersion ({rootState}, args) {
      var apiPath = docsScope(rootState, args.propertyId) + `/resources/files/${args.fileId}/versions/${args.number}/restore`
      return axios.post(apiPath, {}).then(function (result) { return result.data })
    },
    // args: { propertyId|null, folderIds: [], fileIds: [] } -> resolves { blob, contentDisposition }. Rejects on failure.
    downloadZip ({rootState}, args) {
      var apiPath = docsScope(rootState, args.propertyId) + '/resources/download-zip'
      return axios.post(apiPath, { folderIds: args.folderIds || [], fileIds: args.fileIds || [] }, {
        responseType: 'blob',
        headers: { 'accept': 'application/zip' }
      }).then(function (response) {
        var headers = response.headers || {}
        return { blob: response.data, contentDisposition: headers['content-disposition'] || '' }
      })
    },
    // args: { propertyId|null, fileId, name } -> always resolves { success, failureReason, ... }
    renameFile ({rootState}, args) {
      var apiPath = fileCommandBase(rootState, args.propertyId) + `/${args.fileId}/rename`
      return axios.put(apiPath, { name: args.name }).then(function (result) {
        var data = result.data || {}
        if (data.success !== true && !data.failureReason) data.failureReason = 'The file could not be renamed.'
        return data
      }).catch(function (e) {
        var data = (e && e.response && e.response.data) || {}
        var reason = (typeof data === 'object' && data.failureReason) || (typeof data === 'string' && data.length < 300 && data) || 'The request failed. Please try again.'
        return { success: false, failureReason: reason }
      })
    },
    async getAcceptedFileTypes ({commit, state, rootState, dispatch}, args) {
      console.log('getting accepted document types')
      // types: 1 = document, 2 = image, 3 = video
      const types = [
        // Documents
        {type: 1, ext: 'pdf', class: 'fas fa-file-pdf', color: 'rgb(244, 15, 2)'},
        {type: 1, ext: 'xlsx', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'xls', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'csv', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'ppt', class: 'fas fa-file-powerpoint', color: 'rgb(204, 85, 0)'},
        {type: 1, ext: 'pptx', class: 'fas fa-file-powerpoint', color: 'rgb(204, 85, 0)'},
        {type: 1, ext: 'docx', class: 'fas fa-file-word', color: 'rgb(64, 114, 196)'},
        {type: 1, ext: 'doc', class: 'fas fa-file-word', color: 'rgb(64, 114, 196)'},
        {type: 1, ext: 'txt', class: 'fas fa-file', color: 'rgb(92, 92, 92)'},
        // Images
        {type: 2, ext: 'jpg', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'jpeg', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'gif', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'png', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'heic', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'heif', class: 'fas fa-image', color: 'blue'},
        // Videos
        {type: 3, ext: 'mov', class: 'fas fa-video', color: 'orange'},
        {type: 3, ext: 'mp4', class: 'fas fa-video', color: 'orange'},
        {type: 3, ext: 'webm', class: 'fas fa-video', color: 'orange'}
      ]

      return new Promise(resolve => {
        resolve(types)
      })
    }
  }
}
